import Scene = Phaser.Scene;
import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import SpriteContainer from "@/scenes.ui/sprite-container";
import {GiftInfo} from "@/store/gift/types";
import {GiftUtils} from "@/utils/gift-utils";
import CU from "@/utils/c-u";

export default class GiftNavPanel extends AbstractNavPanel {

    private clickCallback!: (id: number) => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, gifts: GiftInfo[],
                clickCallback: (id: number) => unknown) {
        super(scene, canvas, x, y, gifts, 5);

        this.x = x;
        this.y = y;
        this.clickCallback = clickCallback;
    }

    protected makePanel(x: number, element: any): any {
        let self = this;
        let gi = <GiftInfo>element;
        let spriteCont = new SpriteContainer(this.scene!, x * CU.S, 30 * CU.S, GiftUtils.getAtlas(gi.giftId), gi.giftId, () => {
            self.clickCallback(gi.id);
        });
        spriteCont.setDepth(1000);

        return spriteCont;
    }

    protected getButtonX(): number {
        return 250;
    }

    protected getButtonY(): number {
        return 30;
    }

    protected getMaxDisplayedElements(): number {
        return 5;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return 96;
    }



}

